import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Briefcase, ArrowRight } from 'lucide-react';
import { services } from '../mock';
import { useI18n } from '../i18n';
import { Button } from '../components/ui/button';

const Fleet = () => {
  const { t, lang } = useI18n();
  return (
    <div className="pt-[72px] bg-white">
      <section className="bg-black text-white py-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <p className="text-[11px] tracking-[0.4em] uppercase text-white/60">Fleet</p>
          <h1 className="font-serif text-5xl md:text-6xl mt-4 max-w-3xl">{t('fleet.title')}</h1>
          <p className="text-white/70 mt-5 max-w-2xl">{t('fleet.subtitle')}</p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 space-y-20">
          {services.map((s, idx) => (
            <div key={s.id} className={`grid lg:grid-cols-2 gap-10 items-center ${idx % 2 === 1 ? 'lg:[&>div:first-child]:order-2' : ''}`}>
              <div className="aspect-[16/10] overflow-hidden bg-[#eee]">
                <img src={s.image} alt={s.nameFr} className="w-full h-full object-cover" />
              </div>
              <div>
                <p className="text-[11px] tracking-[0.4em] uppercase text-black/50">{s.examples}</p>
                <h2 className="font-serif text-4xl md:text-5xl mt-3">{lang === 'fr' ? s.nameFr : s.nameEn}</h2>
                <p className="text-black/60 mt-5 leading-relaxed">{lang === 'fr' ? s.descFr : s.descEn}</p>
                <div className="flex gap-8 mt-8">
                  <div>
                    <Users className="w-5 h-5" />
                    <p className="text-2xl font-serif mt-2">{s.pax}</p>
                    <p className="text-xs uppercase tracking-widest text-black/50">{t('fleet.pax')}</p>
                  </div>
                  <div>
                    <Briefcase className="w-5 h-5" />
                    <p className="text-2xl font-serif mt-2">{s.luggage}</p>
                    <p className="text-xs uppercase tracking-widest text-black/50">{t('fleet.luggage')}</p>
                  </div>
                </div>
                <Link to="/contact" className="inline-block mt-8">
                  <Button className="bg-black hover:bg-black/85 text-white rounded-none h-12 px-8 text-sm tracking-[0.2em] uppercase">
                    {t('fleet.book')} <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Fleet;
